module.exports = __webpack_public_path__ + "img/martijn.dc618c47.jpg";